// extracted by mini-css-extract-plugin
export default {"search-box":"style_search-box__649oP"};